import React from 'react';
import styles from './Faq.module.scss';
import MultiSelect from '../../miscellaneous/MultiSelect/MultiSelect';
import { IoChevronDownSharp, IoChevronUpSharp } from 'react-icons/io5';
import { $t } from '../../../helpers/translator';
import Loader from '../../../components/miscellaneous/Loader/Loader';
import _ from "lodash";

import flowSwitch from '../../../assets/service/flowSwitch.svg'
import noPic from '../../../assets/service/noPic.svg'
import hardware from '../../../assets/service/flowSwitch.svg'
import thermal from '../../../assets/service/thermal.svg'
import sopranoSmallIcon from '../../../assets/service/sopranoSmallIcon.svg'
import personalDetails from '../../../assets/service/personalDetails.svg'


const images = {
    flowSwitch: flowSwitch,
    noPic: noPic,
    hardware: hardware,
    thermal: thermal,
    sopranoSmallIcon: sopranoSmallIcon,
    personalDetails: personalDetails
}

class ClinicFaq extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedTopic: 0,
            questionsToShow: [],
            faqData: null,
            faqTopQuestions: null,
            selectedQuestion: null
        };
    }

    componentDidMount() {
        let questions = $t('faq.questions');
        let labels = $t('faq.labels');

        let faqData = [{
            label: 'All',
            value: 0,
            questions: []
        }];
        let faqTopQuestions = [];

        _.forEach(questions, (v, k) => {
            let label = labels[v.label];    //text label of question v
            let index = _.findIndex(faqData, function (o) {
                return o.label === label;
            });    //index of label

            if (index === -1) {
                faqData.push({
                    label: label,
                    value: faqData.length,
                    questions: []
                });
                index = faqData.length - 1;
            }
            faqData[index].questions.push(v);

            if (v.topQuestion) {
                faqTopQuestions.push({
                    img: v.img,
                    header: v.question,
                    question: `${index}-${faqData[index].questions.length - 1}`
                });
            }
        });

        this.setState({
            faqData: faqData,
            faqTopQuestions: faqTopQuestions,
        }, () => {
            this.selectionTopicChangeHandler({ value: 0 });
        });
    }

    selectionTopicChangeHandler(data) {
        if (data && data.value === 0) {
            let questionsToShow = [];
            _.forEach(this.state.faqData, (v, k) => {
                _.forEach(v.questions, (qv, qk) => {
                    qv.topic = v.label;
                    questionsToShow.push(qv);
                });
            });

            this.setState({
                questionsToShow: questionsToShow,
                selectedTopic: data.value,
                selectedQuestion: null
            });
            return;
        }

        this.setState({
            questionsToShow: this.state.faqData[data.value].questions,
            selectedTopic: data.value,
            selectedQuestion: null
        });
    }

    toggleSelectedQuestion(key) {
        if (this.state.selectedQuestion === key) {
            key = null;
        }
        this.setState({ selectedQuestion: key });
    }

    selectQuestion(key) {
        this.setState({
            selectedTopic: parseInt(key.split('-')[0]),
            questionsToShow: this.state.faqData[parseInt(key.split('-')[0])].questions
        }, () => {
            this.setState({ selectedQuestion: parseInt(key.split('-')[1]) });
        });
    }


    render() {
        return (
            <div className={`alma-box ${styles['container']}` }>
                <div className={'alma-box-header'}>
                    <span><h3>{$t('global.service.faq')}</h3></span>
                </div>

                <div>
                    {/*{this.state.faqTopQuestions ?*/}
                    {/*    <div className={`${styles['top-questions-container']}` }>*/}
                    {/*        {this.state.faqTopQuestions.map((v, k) => (*/}
                    {/*            <div className={`${styles['top-q-container']}` }*/}
                    {/*                 key={k}*/}
                    {/*                 onClick={() => this.selectQuestion(v.question)}>*/}

                    {/*                <div className={`${styles['image-container']}` }>*/}
                    {/*                    <img src={images[v.img]} alt={v.header} style={{ maxWidth: '30px' }}/>*/}
                    {/*                </div>*/}

                    {/*                <div>*/}
                    {/*                    {v.header}*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*        ))}*/}
                    {/*    </div>*/}
                    {/*    :*/}
                    {/*    <Loader/>*/}
                    {/*}*/}
                    <div>

                    </div>
                </div>

                {this.state.faqData ?
                    <div className={`${styles['topic-selector']}` }>
                        <MultiSelect
                            options={this.state.faqData}
                            selected={{
                                value: this.state.selectedTopic,
                                label: this.state.faqData[this.state.selectedTopic].label
                            }}
                            onValueChange={(data) => this.selectionTopicChangeHandler(data)}
                        />
                    </div>
                    :
                    null
                }

                <div className={`${styles['questions-container']}` }>
                    {this.state.questionsToShow.map((v, k) => (
                        <div key={k}
                             className={`${styles['q-container']} ${styles[(this.state.selectedQuestion === k ? 'q-container-selected' : '')]}`}
                             key={k}
                             onClick={() => this.toggleSelectedQuestion(k)}>

                            <div className={`${styles['q-header-container']}` }>
                                <div>
                                    <span className={`${styles['topic-name-badge']}` }>{this.state.selectedTopic === 0 ? v.topic : this.state.faqData[this.state.selectedTopic].label}</span>
                                </div>
                                <div className={`${styles['q-header']}` }>
                                    <div>{v.question}</div>
                                    {this.state.selectedQuestion === k ?
                                        <IoChevronUpSharp style={{ minWidth: '25px' }}/>
                                        :
                                        <IoChevronDownSharp style={{ minWidth: '25px' }}/>}
                                </div>
                            </div>

                            {
                                this.state.selectedQuestion === k ?
                                    <div className={`${styles['q-answer']}` }>{v.answer}</div>
                                    :
                                    null
                            }
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

export default ClinicFaq;
